import { Builder } from '@builder.io/react'
import React from 'react'

enum PaddingPreset {
  PaddingHalf = 'PaddingHalf',
  PaddingYOne = 'PaddingYOne',
  PaddingYTwo = 'PaddingYTwo',
  PaddingYThree = 'PaddingYThree',
  PaddingYFour = 'PaddingYFour'
}

interface PadderProps {
  backgroundColor: string
  paddingPreset: PaddingPreset
  belowNavbar: boolean
}

export const gettingPaddingClass = (paddingPreset: PaddingPreset) => {
  let classList = ''
  switch (paddingPreset) {
    case PaddingPreset.PaddingHalf:
      classList = 'py-2 lg:py-4'
      break
    case PaddingPreset.PaddingYOne:
      classList = 'py-4 lg:py-8'
      break
    case PaddingPreset.PaddingYTwo:
      classList = 'py-8 lg:py-16'
      break
    case PaddingPreset.PaddingYThree:
      classList = 'py-10 lg:py-20'
      break
    case PaddingPreset.PaddingYFour:
      classList = 'py-12 lg:py-24'
      break
  }

  return classList
}

const Padder = ({ backgroundColor, paddingPreset, belowNavbar }: PadderProps) => {
  const classList = gettingPaddingClass(paddingPreset)
  return <div className={`${classList} ${belowNavbar ? 'lg:-mt-12 lg:pt-12' : ''}`} style={{ backgroundColor }} />
}

export default Padder

Builder.registerComponent(Padder, {
  name: 'Padder',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'paddingPreset',
      type: 'string',
      enum: ['PaddingHalf', 'PaddingYOne', 'PaddingYTwo', 'PaddingYThree', 'PaddingYFour'],
      defaultValue: 'PaddingYOne'
    },
    {
      name: 'belowNavbar',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
